import api from '@/api/resumeVector'

const state = {

}

const actions = {
  getSimilarApplication (context, params) {
    return api.getSimilarApplication(params)
  },
  getSimilarTalent (context, params) {
    return api.getSimilarTalent(params)
  },
  getApplicationSimilaritySummary (context, params) {
    return api.getApplicationSimilaritySummary(params)
  },
  getTalentSimilaritySummary (context, params) {
    return api.getTalentSimilaritySummary(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
